import { OptionsValues } from "components/types";

export const stateOptions = [
  { label: "NSW", value: "nsw" },
  { label: "QLD", value: "qld" },
  { label: "SA", value: "sa" },
  { label: "VIC", value: "vic" },
  { label: "WA", value: "wa" },
  { label: "NT", value: "nt" },
  { label: "ACT", value: "act" },
  { label: "TAS", value: "tas" },
] as const;

export const regionProvinceOptions = [
  {
    label: "Auckland",
    value: "auckland",
  },
  {
    label: "Bay of Plenty",
    value: "bay_of_plenty",
  },
  {
    label: "Canterbury",
    value: "canterbury",
  },
  {
    label: "Christchurch",
    value: "christchurch",
  },
  {
    label: "Coromandel",
    value: "coromandel",
  },
  {
    label: "Dunedin",
    value: "dunedin",
  },
  {
    label: "Eastland",
    value: "eastland",
  },
  {
    label: "Fiordland",
    value: "fiordland",
  },
  {
    label: "Hawke's Bay",
    value: "hawkes_bay",
  },
  {
    label: "Manawatu",
    value: "manawatu",
  },
  {
    label: "Marlborough",
    value: "marlborough",
  },
  {
    label: "Mt Cook",
    value: "mt_cook",
  },
  {
    label: "Nelson",
    value: "nelson",
  },
  {
    label: "Northland",
    value: "northland",
  },
  {
    label: "Otago",
    value: "otago",
  },
  {
    label: "Queenstown",
    value: "queenstown",
  },
  {
    label: "Rotorua",
    value: "rotorua",
  },
  {
    label: "Ruapehu",
    value: "ruapehu",
  },
  {
    label: "Southland",
    value: "southland",
  },
  {
    label: "Taranaki",
    value: "taranaki",
  },
  {
    label: "Taupo",
    value: "taupo",
  },
  {
    label: "Waikato",
    value: "waikato",
  },
  {
    label: "Wairarapa",
    value: "wairarapa",
  },
  {
    label: "Wanaka",
    value: "wanaka",
  },
  {
    label: "Wanganui",
    value: "wanganui",
  },
  {
    label: "Wellington",
    value: "wellington",
  },
  {
    label: "West Coast",
    value: "west_coast",
  },
] as const;

export const yesNoOptions = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
] as const;

export type YesNo = OptionsValues<typeof yesNoOptions>;
